import React, {useState, useEffect} from 'react';
import {useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import axios from "axios";

const InventorygrnFormComponent = (props) => {

  const {t} = props;
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    if ((!window.App.urlVars().create && window.App.urlVars().inventorygrnId) || (entity === 'inventory-grn' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/inventory-grn/' + (window.App.urlVars().inventorygrnId ?? id))
        .then(response => {
          setFormData(response.data.data)
          props.onLoaded(response.data.data || {});
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  return (
    <div className={"inventorygrn-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-4"}>
          <div className="p-field p-fluid">
            <label htmlFor="location">{t('columnDate')}</label>
            <span className="p-d-block fake-input">
              {formData?.date}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-4"}>
          <div className="p-field p-fluid">
            <label htmlFor="location">{t('columnDeliveryNote')}</label>
            <span className="p-d-block fake-input">
              {formData?.delivery_note?.document_number}
            </span>
          </div>
        </div>
      </div>

      {id &&
        <div className={"p-grid p-mt-3"}>
          <div className={"p-col-12 p-lg-12"}>
            <h4 className={"p-mt-0"}>{t('products')}</h4>
            <DataTable
              emptyMessage={t('noResults')}
              size={"small"}
              value={formData.items}
              autoLayout={true}
              responsiveLayout="scroll"
              stripedRows
              dataKey="id"
            >
              <Column field="material.name" header={t('columnName')} sortable></Column>
              <Column header={t('quantity')} sortable className={"p-text-right"} body={(rowData) => {
                return (
                  <>
                    {Number(rowData?.quantity)} {rowData?.unit?.name}
                  </>
                )
              }}></Column>
            </DataTable>
          </div>
        </div>
      }

    </div>
  )
}
export default withTranslation('common')(InventorygrnFormComponent);
